/**
 * Projected fields for the profile backer-rewards list. Shared by every
 * surface on the profile that reads it (the rewards card and the Created
 * list) so their hook args produce one query key and one fetch.
 */
export const BACKER_REWARDS_FIELDS = [
  'marketPubkey',
  'marketTitle',
  'marketImageUrl',
  'marketState',
  'vaultD6',
  'supplyD6',
  'userShareD6',
  'backedD6',
  'backedTotalD6',
  'earnedD6',
  'claimedTotalD6',
  'canClaim',
] as const;
